/* eslint-disable no-use-before-define */
import { cleanObject, arrayFrom, formatDate } from '../../twd'

export const toSearchParams = (values) => {
    let p = Object.assign({
        holdUnderlyingRating: 'NO',
        offeringType: ['ask-side'],
    }, values)

    p.ytwMin = p.offerYtwMin
    p.ytwMax = p.offerYtwMax

    delete p.holdCorpSectorCode
    delete p.holdCorpType

    arrayFrom(p.sectors).forEach((s) => {
        let [k,v] = s.split('=')
        if (!p[k]) p[k] = []

        let arr = p[k]
        let i = arr.indexOf(v)
        if (i<0) arr.push(v)
    })
    delete p.sectors

    if (p.holdCallableInd) {
        p.holdCallableInd = ['N']
        p.holdCallFeatures = ['holdCallableInd-N']
    } else {
        delete p.holdCallableInd
    }

    if (['AND','OR'].indexOf(p.holdRatingAndOr)<0) {
        p.holdRatingAndOr = p.holdRatingAndOr===true ? 'OR' : 'AND'
    }

    p.holdMaturityMin = formatDate(p.holdMaturityMin)
    p.holdMaturityMax = formatDate(p.holdMaturityMax, true)

    return cleanObject(p)
}



// WEBPACK FOOTER //
// ./src/corporates/quick-screener/to-search-params.js